/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { AgentContactPageComponent } from '@src/app/modules/agent/agent-contact-page/agent-contact-page.component';
import { ContactTypes } from '@src/app/model/person';
import { TableView } from '@src/app/model/sys/nav-item';
import { NavRoute } from '@src/app/shared/NavRoute';

export const AgentContactPageNavRoute = new NavRoute('agent/contacts', () => AgentContactPageComponent, 'people').setViews(() => {
    return [
        {
            id: 'agencyStaff',
            name: $localize `Agency`,
            filterFields: { contactType: ContactTypes.agent, lastName: null, firstName: null, keyword: null },
            sort: 'lastName',
            helpText: $localize `Staff and owners of the managing agency`,
        } as TableView,
        {
            id: 'supplierContacts',
            name: $localize `Suppliers`,
            filterFields: { contactType: ContactTypes.supplier, lastName: null, firstName: null, keyword: null },
            sort: 'lastName',
            helpText: $localize `Contacts at the suppliers the agency works with`,
        } as TableView,
        {
            id: 'allAgentContacts',
            name: $localize `All`,
            filterFields: { contactType: null, lastName: null, firstName: null, keyword: null },
            sort: 'lastName',
            helpText: $localize `All contacts held in the agency team`,
        } as TableView,
    ];
});
